import { MediaDetailCsvQuery } from './MediaDetailAnalytics.codegen'
import { t } from '@lingui/macro'

export const prepareMediaDetailExport = (
  data: MediaDetailCsvQuery['analytics']['media']['impressionsOverview']
) =>
  data?.[0].items.map((row) => {
    return {
      [t`Display name`]: row.topicEnrolment.user.display_name,
      [t`User ID`]: row.topicEnrolment.user.id,
      [t`Play`]: row.total_play_time_ms > 0,
      [t`Engagement percent`]: row.engagementPercent,
      [t`Total play time ms`]: row.total_play_time_ms,
      [t`Total unique play time ms`]: row.total_unique_play_time_ms,
      [t`Created at`]: row.created_at,
      [t`LastActive at`]: row.lastActiveAt,
      [t`Finished at`]: row.finished_at,
      [t`Deleted at`]: row.deleted_at
    }
  })
